import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getAllExperienceTypes } from '../../../data/experienceTypes';
import { getExperienceTypeIcon } from '../../../utils/experienceTypeIcons';

export default function StartExperienceCard({ suggestion }) {
  const navigate = useNavigate();
  const experienceTypes = getAllExperienceTypes();
  const experienceType = experienceTypes.find(t => t.id === suggestion.suggestedType);

  const handleStart = () => {
    // Navigate to dashboard and trigger experience creation
    navigate('/');
    // Could dispatch an event to open create modal with pre-selected type
    window.dispatchEvent(new CustomEvent('createExperience', { 
      detail: { type: suggestion.suggestedType } 
    }));
  };

  return (
    <motion.div
      whileHover={{ y: -6 }}
      transition={{ duration: 0.2 }}
      onClick={handleStart}
      className="group bg-gradient-to-br from-primary/5 to-accent/5 rounded-2xl border border-primary/20 overflow-hidden cursor-pointer shadow-sm hover:shadow-xl transition-all duration-300"
    >
      <div className="p-5">
        <div className="flex items-center gap-3 mb-3">
          <div className="w-12 h-12 rounded-xl bg-primary/20 flex items-center justify-center">
            <FontAwesomeIcon 
              icon={getExperienceTypeIcon(experienceType?.icon)} 
              className="text-primary text-2xl" 
            />
          </div>
          <div className="flex-1 min-w-0">
            <span className="text-xs font-semibold text-primary uppercase tracking-wide">Start New</span>
            <h3 className="font-serif font-bold text-lg text-text-primary line-clamp-1 group-hover:text-primary transition-colors mt-1">
              Plan {suggestion.holiday}
            </h3>
          </div>
        </div>
        
        <div className="flex items-center gap-1 text-sm text-text-secondary mb-4">
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
          </svg>
          <span>{suggestion.daysUntil} days until {suggestion.holiday}</span>
        </div>
      </div>
      
      {/* Footer with arrow */}
      <div className="px-5 pb-5">
        <div className="flex items-center justify-between text-sm font-semibold text-primary opacity-0 group-hover:opacity-100 transition-opacity">
          <span>Get started</span>
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
        </div>
      </div>
    </motion.div>
  );
}

